import type { SupplierPolicy } from '@tandemone/types'
import { Check, X } from 'lucide-react'
import { Fragment } from 'react'

import { ProfileEmpty } from './profile-empty'
import { ProfileSection } from './profile-section'

const POLICY_LABELS: Array<[keyof SupplierPolicy, string]> = [
  ['hsePolicy', 'Health, Safety & Environment'],
  ['codeOfEthicsPolicy', 'Code of Ethics'],
  ['socialLaborPolicies', 'Social & Labor Policies'],
  ['disasterManagementPlan', 'Disaster Management Plan']
]

export function ProfilePolicies({
  companyName,
  policies
}: {
  companyName: string
  policies: SupplierPolicy | null
}) {
  return (
    <ProfileSection title={`${companyName} Policies & Compliance`}>
      {policies === null ? (
        <ProfileEmpty message='No policy responses submitted.' />
      ) : (
        <div className='grid grid-cols-[1fr_auto] [&>*]:py-1.5 [&>*:nth-child(n+3)]:border-t [&>*:nth-child(n+3)]:border-border'>
          {POLICY_LABELS.map(([key, label]) => (
            <Fragment key={key}>
              <span className='flex items-center text-sm text-foreground'>
                {label}
              </span>
              <span className='flex items-center justify-end pl-3'>
                {policies[key] ? (
                  <Check
                    className='size-4 text-emerald-700'
                    strokeWidth={2.5}
                  />
                ) : (
                  <X className='size-4 text-red-600' strokeWidth={2.5} />
                )}
              </span>
            </Fragment>
          ))}
        </div>
      )}
    </ProfileSection>
  )
}
